import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'mobx-react'

import Store from '~src/store'
import ErrorBoundary from '~src/core/services/exceptions/ErrorBoundary'
import ready from '~src/core/ready'

import { ELEMENT_SELECTOR } from './meta'

import './ObscurableNavigation.scss'

function TraverseElements ({
  element,
  linkSelector = '.navigation__link',
  hrefAttribute = 'href',
  filterFn = (element) => Array.from(element.classList).includes('navigation__item')
}) {
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_ELEMENT,
    null,
    false)

  const output = []

  while (walker.nextNode()) {
    const childElement = walker.currentNode
    if (!filterFn(childElement)) continue
    const linkElement = childElement.querySelector(linkSelector)

    output.push({
      label: linkElement.textContent.trim(),
      href: linkElement.getAttribute(hrefAttribute),
      items: TraverseElements({
        element: childElement,
        filterFn
      })
    })
  }

  return output
}

ready(() => {
  document.querySelectorAll(ELEMENT_SELECTOR)
    .forEach(function (element) {
      const items = TraverseElements({ element })
      // eslint-disable-next-line no-undef
      import(
        // this causes webpack to create a new output file of this name
        /* webpackChunkName: "component__example" */
        './ObscurableNavigationContainer')
        .then(({ default: ObscurableNavigationContainer }) => {
          render(
            <Provider store={Store}>
              <ErrorBoundary>
                <ObscurableNavigationContainer
                  items={items}
                  {...element.dataset}
                />
              </ErrorBoundary>
            </Provider>,
            element)
        })
    })
})
